/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { GetTaskListRequest, TasksApi } from "client";
import { useApiWithTimeout } from "./ApiWrapperWithTimeout";
import { Const } from "const";
import { useState } from "react";
import { useCallApi } from "./CallApiHook";

export const useGetTaskList = () => {
  const [getTasksApi, cancelGetTasksApi] = useApiWithTimeout(
    TasksApi,
    Const.operationTimeout.getTaskList
  );
  const [request, setRequest] = useState<GetTaskListRequest>();

  const result = useCallApi(
    async () => {
      if (request?.frameTypeAndNumber && request.mapId) {
        const resultTaskList = await getTasksApi.getTaskList(request);
        if (resultTaskList === undefined) {
          return {};
        }
        return resultTaskList;
      }
    },
    cancelGetTasksApi,
    [getTasksApi, cancelGetTasksApi, request]
  );
  return { ...result, setRequest };
};
